import { IApi } from '@/setup/api-client'
import { useApiMutation } from '@/utils/api/api-mutation'
import { useApiToolbox } from '@/utils/api/use-api-toolbox'
import type { IEnsureReferralCodeResponseData } from 'api/dist/routes/organization/[organization_id]/referral-code/index.js'
import { GetDatabaseOrganizationQuery } from './get-database-organization'

interface IEnsureReferralCodeArgs {
    organizationId: string
}

export class EnsureReferralCodeMutation {
    static async call(api: IApi, args: IEnsureReferralCodeArgs) {
        return api
            .post<
                IEnsureReferralCodeResponseData,
                undefined
            >(`/organization/${args.organizationId}/referral-code`, undefined)
            .then((res) => res.data)
    }
}

export function useEnsureReferralCodeMutation() {
    const { api, apiParams, qc } = useApiToolbox()

    return useApiMutation<IEnsureReferralCodeResponseData, void>({
        mutationFn: () =>
            EnsureReferralCodeMutation.call(api, {
                organizationId: apiParams.organizationId,
            }),
        onSuccess: () => {
            qc.invalidateQueries({
                queryKey: GetDatabaseOrganizationQuery.getKey({ organizationId: apiParams.organizationId }),
            })
        },
    })
}
